import { colorTokens, KariusButton } from '@kariusdx/design-system';
import { Box, Modal, Stack, Typography } from '@mui/material';
import React from 'react';

export const linkSx = {
  color: colorTokens.text_link,
  fontWeight: 500,
  textDecoration: 'underline',
};

export const bodySx = {
  fontSize: '14px',
  lineHeight: '20px',
  letterSpacing: '0.25px',
};

interface LoginModalShellProps {
  open: boolean;
  onClose: () => void;
  titleId: string;
  descriptionId: string;
  title: React.ReactNode;
  children: React.ReactNode;
}

export const LoginModalShell: React.FC<LoginModalShellProps> = ({
  open,
  onClose,
  titleId,
  descriptionId,
  title,
  children,
}) => (
  <Modal open={open} onClose={onClose} aria-labelledby={titleId} aria-describedby={descriptionId}>
    <Box
      sx={{
        position: 'absolute',
        top: '35%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 410,
        bgcolor: 'background.paper',
        p: 5,
      }}
    >
      <Typography id={titleId} sx={{ fontSize: '20px' }}>
        {title}
      </Typography>

      <Stack id={descriptionId} sx={{ mt: '21px' }}>
        {children}
        <Box sx={{ textAlign: 'right', mt: '20px' }}>
          <KariusButton
            color='primary'
            variant='tertiary'
            sx={{ border: '1px solid', borderColor: colorTokens.interactive, borderRadius: '20px', fontSize: '12px' }}
            onClick={onClose}
          >
            Close
          </KariusButton>
        </Box>
      </Stack>
    </Box>
  </Modal>
);
